// Remove once ShowPaymentBatchesOnListFromClosedListings is removed.

import * as React from 'react';
import { DateLabel } from './date-label';

export const BatchInfoLabelOld = (props: {prefix: string, name: string, date: Date}) => {
	const { prefix, name, date } = props;
	return <span>{prefix} {name} <DateLabel date={date} /></span>;
};
